import axios from '../config/axios';
import StorageService from '../services/StorageService';

class PartnerHttpService {
    static async getPartners(search = '') {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/partners?search=${encodeURIComponent(search)}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            // Retorna diretamente o array de dados
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async createPartner(data) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/partners`,
                data,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async updatePartner(id, data) {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/partners/${id}`,
                data,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async deletePartner(id) {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/partners/${id}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default PartnerHttpService;
